import { css } from 'styled-components';

import { type Theme } from '@/utils/theme/themes';

export const styles = {
  h0: `heading-0`,
  h1: `heading-1`,
  h2: `heading-2`,
  h3: `heading-3`,
  h4: `heading-4`,
  h5: `heading-5`,
  h6: `heading-6`
};

export const HeadingDeclarations = css<{ theme?: Theme }>`
  .${styles.h0} {
    font-family: ${({ theme }) => theme.fontFamily.DISPLAY};
    font-weight: ${({ theme }) => theme.fontWeight.h0};
    line-height: ${({ theme }) => theme.lineHeight.h};
    letter-spacing: ${({ theme }) => theme.letterSpacing.h0};
    font-size: ${({ theme }) => theme.fontSize.h0};
  }

  .${styles.h1} {
    font-family: ${({ theme }) => theme.fontFamily.DISPLAY};
    font-weight: ${({ theme }) => theme.fontWeight.h1};
    line-height: ${({ theme }) => theme.lineHeight.h};
    letter-spacing: ${({ theme }) => theme.letterSpacing.h1};
    font-size: ${({ theme }) => theme.fontSize.h1};
  }

  .${styles.h2} {
    font-family: ${({ theme }) => theme.fontFamily.HEADING};
    font-weight: ${({ theme }) => theme.fontWeight.h2};
    line-height: ${({ theme }) => theme.lineHeight.h};
    letter-spacing: ${({ theme }) => theme.letterSpacing.h2};
    font-size: ${({ theme }) => theme.fontSize.h2};
  }

  .${styles.h3} {
    font-family: ${({ theme }) => theme.fontFamily.HEADING};
    font-weight: ${({ theme }) => theme.fontWeight.h3};
    line-height: ${({ theme }) => theme.lineHeight.h};
    letter-spacing: ${({ theme }) => theme.letterSpacing.h3};
    font-size: ${({ theme }) => theme.fontSize.h3};
  }

  .${styles.h4} {
    font-family: ${({ theme }) => theme.fontFamily.HEADING};
    font-weight: ${({ theme }) => theme.fontWeight.h4};
    line-height: ${({ theme }) => theme.lineHeight.h};
    letter-spacing: ${({ theme }) => theme.letterSpacing.h4};
    font-size: ${({ theme }) => theme.fontSize.h4};
  }

  .${styles.h5} {
    font-family: ${({ theme }) => theme.fontFamily.SANS};
    font-weight: ${({ theme }) => theme.fontWeight.h5};
    line-height: ${({ theme }) => theme.lineHeight.h5};
    letter-spacing: ${({ theme }) => theme.letterSpacing.h5};
    font-size: ${({ theme }) => theme.fontSize.h5};
  }

  .${styles.h6} {
    font-family: ${({ theme }) => theme.fontFamily.MONO};
    font-weight: ${({ theme }) => theme.fontWeight.h6};
    line-height: ${({ theme }) => theme.lineHeight.h6};
    letter-spacing: ${({ theme }) => theme.letterSpacing.h6};
    font-size: ${({ theme }) => theme.fontSize.h6};
  }
`;
